import { useMutation } from "@tanstack/react-query";
import { api } from "api";
import { LoanDto, LoanSchemaDto } from "types/loan.types";
import { T_Api_Success_Res } from "./api.types";

export const loansService = {
  useCreate: () => {
    return useMutation({
      mutationKey: ["loans/create"],
      mutationFn: async (body: LoanDto & { application_id: string }) => {
        const res = await api.post(`/loans`, body);
        return res.data as T_Api_Success_Res<LoanSchemaDto>;
      },
    });
  },

  useUpdate: (loanId: string | null) => {
    return useMutation({
      mutationKey: ["loans/update", loanId],
      mutationFn: async (body: Partial<LoanSchemaDto>) => {
        const res = await api.patch(`/loans/${loanId}`, body);
        return res.data as T_Api_Success_Res<LoanSchemaDto>;
      },
    });
  },

  useBulkUpdate: () => {
    return useMutation({
      mutationKey: ["loans/bulk-update"],
      mutationFn: async (body: { loans: Partial<LoanSchemaDto>[] }) => {
        const res = await api.post(`/loans/bulk-update`, body);
        return res.data as T_Api_Success_Res<LoanSchemaDto>;
      },
    });
  },

  useDelete: () => {
    return useMutation({
      mutationKey: ["loans/delete"],
      mutationFn: async (loanId: string) => {
        const res = await api.delete(`/loans/${loanId}`);
        return res.data as T_Api_Success_Res<LoanSchemaDto>;
      },
    });
  },

  useUpdateStage: () => {
    return useMutation({
      mutationFn: async ({ appKey, loanId, stage }: { appKey: string; loanId: string; stage: string }) => {
        const { data } = await api.patch<T_Api_Success_Res<unknown>>(
          `/application/loan/stage/${loanId}`,
          { id: stage },
          { params: { appKey } },
        );
        return data.result;
      },
    });
  },
};
